import CustomerKYCRepository from "@/core/customers/repositories/CustomerKYCRepository";
import { CustomerKYCUpdateDTO } from "@/core/customers/entities/CustomerKYCUpdate";

export default class UpdateCustomerKYCUseCase {
  constructor(private readonly repository: CustomerKYCRepository) {}

  /**
   * Execute partial update of customer KYC data.
   * @throws Error if no updates provided
   */
  async execute(params: {
    businessKey: string;
    updates: Partial<CustomerKYCUpdateDTO>;
  }): Promise<boolean> {
    if (Object.keys(params.updates).length === 0) {
      throw new Error("No updates provided");
    }

    return await this.repository.updateCustomerKYC(
      params.businessKey,
      params.updates,
    );
  }
}
